"use client"
import LandingPage from "@/components/landing-page/landingPage";
import PreFooter from "@/components/sections/preFooter";
import { useEffect, useState } from "react";
import { API_BASE_URL, USE_BACKEND } from "@/app/api/variable";
import axios from "axios";
import { Service } from "./shared/type";
import ClientOnly from "@/components/layout/ClientOnly";
import servicesData from "@/app/data/service.json";

export default function Home() {
  const [services, setServices] = useState<Service[]>([]);

  const fetchData = async () => {
    if(USE_BACKEND){
    try {
      const servicesRes = await axios.get<Service[]>(`${API_BASE_URL}/service`);
      setServices(servicesRes.data);
    } catch (err) {
      console.error("Error fetching data:", err);
      setServices([]);
    }
  }else{
      setServices(servicesData as Service[]);   
  }
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="">
      <ClientOnly>
        <LandingPage services={services}/>
      </ClientOnly>
      
      {/* <ClientOnly>
        <PreFooter services={services}/>
      </ClientOnly> */}
    </div>
  );
}
